/* eslint-disable arrow-body-style */
import React from "react";

const Footer = () => {
  return (
    <footer className="border-t border-gray-200 py-4 bg-[#fafafa] w-full mt-auto">
      <div className="flex justify-between items-center flex-wrap px-3 py-0">
        {/* sm:px-6 md:px-8 lg:px-10 xl:px-12 */}
        <p className="text-sm text-black">
          Copyright © 2026 keySkillset
        </p>
        <p className="text-sm text-gray-500">
          Need help?{" "}
          <a
            href="mailto:contact@keyskillset.com"
            className="font-medium text-[#1976d2] hover:underline"
          >
            Contact Support
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;